import React from 'react';
import { H3, H6 } from 'scy/text';
import margin from 'scy/margin.mod.scss';
import { uppercase } from 'scy/text/styles.mod.scss';

export default function ForgotHeader() {
  return (
    <>
      <H3 tag="h1" marginClass={`${margin.top_0} ${margin.bottom_sm}`}>
        Forgot Password?
      </H3>
      <H6
        tag="h2"
        marginClass={`${margin.top_0} ${margin.bottom_md}`}
        className={uppercase}
      >
        Take a few breaths. We will get through this.
      </H6>
    </>
  );
}
